<template>
    <NuxtLayout>
        <div class="error-page">
            <h1 class="error-page__title">
                404
            </h1>
            <p class="error-page__text">
                This page was not found.
            </p>
            <div class="error-page__actions">
                <!-- Plain anchors, not NuxtLink: a full document load is what drops the
                     error state, and the destinations are outside the failed route. -->
                <KButton
                    as="a"
                    href="/"
                    size="lg"
                    label="Go back"
                >
                    <template #icon-start>
                        <Icon name="tabler:home" />
                    </template>
                </KButton>
                <KButton
                    as="a"
                    href="/search"
                    size="lg"
                    variant="secondary"
                    label="Search"
                >
                    <template #icon-start>
                        <Icon name="tabler:search" />
                    </template>
                </KButton>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup>
import { KButton } from '@vemedia/karibu'
</script>

<style lang="scss">
// The layout renders nav / main.page / footer as siblings, so stretch the page
// wrapper to push the footer down on an otherwise short error page.
#__nuxt {
    display: flex;
    flex-direction: column;
    min-height: 90vh;

    > .page {
        display: flex;
        flex-grow: 1;
    }
}

.error-page {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    gap: var(--space-2);
    padding: var(--space-6) var(--space-4);
    text-align: center;

    &__title {
        font-size: var(--font-size-9);
        line-height: 1;
    }

    &__text {
        color: var(--color-text-muted);
        font-size: var(--font-size-5);
    }

    // The buttons carry their own sizing, so this only places them.
    &__actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: var(--space-3);
        margin-top: var(--space-4);
    }
}
</style>
